import { nodesFlux, useEditorSelector } from '@candulabs/craft';
import fromPairs from 'lodash/fromPairs';
import { useContext } from 'react';

import { CollectionContext } from 'craft/contexts';
import { ContentCollection, CollectionTargetLocation } from 'craft/types';

export const usePropsWithCollection = (nodeId: string) => {
  const custom = useEditorSelector(nodesFlux.selectors.getNodeCustom(nodeId));

  const collections: ContentCollection[] = custom.collections || [];
  const { record } = useContext(CollectionContext);

  if (!collections.length || !record) {
    return {};
  }
  return fromPairs(
    collections
      .map(({ fieldId, fallback, targetLocation }) => {
        // TODO: this is quite hacky. we should implement it in a cleaner way
        const propLocation =
          targetLocation === CollectionTargetLocation.Image ? 'src' : targetLocation;
        if (!fieldId) {
          return [];
        }
        return record[fieldId] || fallback
          ? [propLocation, record[fieldId] || fallback]
          : [propLocation, null];
      })
      .filter((entry) => entry.length === 2),
  );
};
